import VehicleImgsAndRegistrationImgFields from "./VehicleImgsAndRegistrationImgFields";

export default VehicleImgsAndRegistrationImgFields;
